/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CancellationParams } from '../../models/cancellation-params';
import { ResponseResponseType } from '../../models/response-response-type';

export interface Canceling$Params {
      body: CancellationParams
}

export function canceling(http: HttpClient, rootUrl: string, params: Canceling$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseResponseType>> {
  const rb = new RequestBuilder(rootUrl, canceling.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseResponseType>;
    })
  );
}

canceling.PATH = '/canceling';
